import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ReactNumberFormat from "react-number-format";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import * as routines from "modules/User/routines";

import * as timeHelpers from "helpers/time";
import * as variables from "constants/variables";

export interface SubscriptionProps {
  plan?: string;
  subtotal?: number;
  total?: number;
  purchased_at: string;
  expires_at: string;
  discount?: number;
  course_id?: number;
  subscription_id?: number;
  course_name?: string;
  certificate: boolean;
  user_id: number;
}


const TRANSLATION_BASE = "modules.subscription";

export default ({
  course_id,
  course_name,
  certificate,
  user_id
}: SubscriptionProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  

  const get_certificate = (user:any) => {
    user = user_id;
    dispatch(
      routines.certificate({
        user,
        onSuccess: () => {
          toast.success(t("global.notification.success"), { position: toast.POSITION.TOP_RIGHT });
          window.open(window.location['href'], "_self");
        },
        onError: (error = {}) => {
          toast.error(t(`${TRANSLATION_BASE}.course_not_passed`), { position: toast.POSITION.TOP_RIGHT });
        }
      })
    )
  }

  const renderPrice = (value: number | string) => (
    <ReactNumberFormat value={value} displayType="text" thousandSeparator=" " />
  );

  return (
    <div className="card-box mb-2" style={{ position: "relative" }}>
      <Row className="align-items-center">
        <Col sm={8}>
          <div className="media">
            <div className="media-body">
              {course_id && (
                <h4 className="mt-0 mb-1 font-16">
                  <b>{t(`${TRANSLATION_BASE}.course`)}:</b> {course_name}
                </h4>
              )}
            </div>
          </div>
        </Col>
        <Col sm={4} className="text-right">{ certificate === null ? <Button onClick={() => get_certificate(user_id)}>{t(`${TRANSLATION_BASE}.get_certificate`)}</Button> :     <Button color="success" onClick={() => window.open(`http://certificate.mtsudex.uz/${certificate}`, "_blank")}>{t(`${TRANSLATION_BASE}.open_certificate`)}</Button> }</Col>
      </Row>
    </div>
  );
};
